import type { Client } from "../client";
import type { NewSpaceResource, SpaceResource } from "../resources";
import BasicRepository from "./basicRepository";

class SpaceRepository extends BasicRepository<SpaceResource, NewSpaceResource> {
    constructor(client: Client) {
        super("Spaces", client);
    }
    search(keyword: string) {
        return this.client.get<SpaceSearchResult[]>(this.client.getLink("SpaceSearch"), { id: this.client.spaceId, keyword: keyword });
    }
}

export interface SpaceSearchResult {
    Id: string;
    Name: string;
    Type: string;
}

export default SpaceRepository;
